import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { PictureGalleryFieldParams } from 'SharedDir/declarations/fields';
import { computed, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'PictureField' },
  __name: 'PictureGallery',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {



const props = __props;

const { getBase64Content } = useFileApi();

const srcContent = ref<(string | ArrayBuffer | null)[]>([]);
const currentImage = ref(0);
const images = computed(() => props.params.files || []);

const getSrcContent = async (files: PictureGalleryFieldParams['files']) => {
  if (!files) return;
  srcContent.value = await Promise.all(files.map(({ fileId }) => getBase64Content(fileId)));
};

watch(
  () => props.params.files,
  (newFiles) => {
    getSrcContent(newFiles);
  },
  { deep: true }
);

onMounted(() => {
  getSrcContent(props.params.files);
});

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!

  return (_openBlock(), _createBlock(_component_q_carousel, {
    modelValue: currentImage.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentImage).value = $event)),
    animated: "",
    arrows: "",
    navigation: "",
    infinite: "",
    "control-color": "brand"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
        return (_openBlock(), _createBlock(_component_q_carousel_slide, {
          key: index,
          name: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              height: "300px",
              contain: "",
              src: srcContent.value[index],
              alt: image.alt
            }, null, 8, ["src", "alt"])
          ]),
          _: 2
        }, 1032, ["name"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})